document.querySelector('.coi-renew-link').addEventListener('click', (e) => {
    const host = document.querySelector('#usercentrics-cmp-ui');

    if (host && host.shadowRoot) {
        const btn = host.shadowRoot.querySelector('#uc-privacy-button');

        if (btn) {
            btn.click();
        }
    }
});